import { inertMainContainerAndSkipLinks, removeInertFromMainContainerAndSkipLinks } from "./services.inert";

export const animationDurationMs = 320;
export const delayAfterReopeningMs = 100;

/** @type {HTMLElement | null} */
const firstBodyElement = document.querySelector("#js-first-element");

/**
 * @param {HTMLElement} [modalEl]
 */
export const onModalOpen = async (modalEl) => {
	inertMainContainerAndSkipLinks();

	if (!modalEl) return;
	await new Promise((resolve) => window.setTimeout(resolve, 60));
	const dialogEl = modalEl.querySelector("[role=dialog]");
	dialogEl?.focus();
};

export const onModalClosed = async (triggerEl = firstBodyElement) => {
	removeInertFromMainContainerAndSkipLinks();

	if (triggerEl === null) return;
	await new Promise((resolve) => window.setTimeout(resolve, 60));
	triggerEl.focus();
};
